/**
 * Contacto Page - Simple contact page
 */

import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Mail, Phone, MapPin } from 'lucide-react';
import { PageWrapper } from '../components/EditorialShared';

const ContactoPage = () => {
  const heroRef = useRef(null);
  const isHeroInView = useInView(heroRef, { once: true });

  return (
    <PageWrapper showLogoFooter={false}>
      <section className="min-h-screen flex items-center justify-center px-6" ref={heroRef}>
        <div className="max-w-4xl text-center">
          <motion.h1
            className="text-white text-5xl md:text-7xl lg:text-8xl font-extralight mb-12"
            initial={{ opacity: 0, y: 60 }}
            animate={isHeroInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1 }}
          >
            ¿Hablamos?
          </motion.h1>

          <motion.p
            className="text-white/50 text-xl md:text-2xl font-light mb-16 max-w-2xl mx-auto"
            initial={{ opacity: 0, y: 30 }}
            animate={isHeroInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.3 }}
          >
            Estamos listos para ayudarte a transformar tu marca.
          </motion.p>

          <motion.div
            className="flex flex-col md:flex-row gap-8 justify-center items-center mb-16"
            initial={{ opacity: 0, y: 20 }}
            animate={isHeroInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.5 }}
          >
            <a
              href="https://wa.me/527774385617"
              target="_blank"
              rel="noopener noreferrer"
              className="px-10 py-5 bg-white text-black font-medium hover:bg-white/90 transition-colors text-lg"
              data-cursor="escribir"
            >
              WhatsApp
            </a>
            <a
              href="mailto:hola@paliacatestudio.com"
              className="px-10 py-5 border border-white/20 text-white hover:bg-white/5 transition-colors text-lg"
              data-cursor="email"
            >
              Enviar email
            </a>
          </motion.div>

          <motion.div
            className="space-y-6 text-white/50"
            initial={{ opacity: 0 }}
            animate={isHeroInView ? { opacity: 1 } : {}}
            transition={{ delay: 0.7 }}
          >
            <div className="flex items-center justify-center gap-3">
              <Mail className="w-5 h-5" />
              <a href="mailto:hola@paliacatestudio.com" className="hover:text-white transition-colors">
                hola@paliacatestudio.com
              </a>
            </div>
            <div className="flex items-center justify-center gap-3">
              <Phone className="w-5 h-5" />
              <a href="tel:+527774385617" className="hover:text-white transition-colors">
                +52 777 438 5617
              </a>
            </div>
            <div className="flex items-center justify-center gap-3">
              <MapPin className="w-5 h-5" />
              <span>Cuernavaca, Morelos, México</span>
            </div>
          </motion.div>
        </div>
      </section>
    </PageWrapper>
  );
};

export default ContactoPage;
